import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { RunningLate } from '~weekly-planner/lib/common';

import { typePrefix as prefix } from '~weekly-planner/actions/users';

export const typePrefix = `${prefix}-running-late`;

type Request = Record<string, unknown> | undefined;

export const usersRunningLateApi = createApi({
  reducerPath: 'weeklyPlannerUsersRunningLateApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['users-running-late'],
  endpoints: (builder) => ({
    getUsersRunningLate: builder.query<RunningLate, Request>({
      query: (arg) => {
        const { __refetchKey, ...params } = (arg ?? {}) as any;
        return { url: '/users/exceptions', method: 'GET', params };
      },
      providesTags: [{ type: 'users-running-late', id: 'LIST' }],
      transformResponse: (payload) => unwrap<RunningLate>(payload),
    }),
  }),
});

export const { useGetUsersRunningLateQuery } = usersRunningLateApi;
